/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbStepperModule,
  NbTabsetModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { LoginComponent } from './pages/auth/login/login.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Interceptor } from './services/interceptor';
import { LogoutComponent } from './pages/auth/logout/logout.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { GithubService } from './services/github.service';
import { AuthService } from './services/auth.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { of } from 'rxjs';
import { NbAuthModule } from '@nebular/auth';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';


export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return of('guest');
  }
}

@NgModule({
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    NbLayoutModule,
    NbTabsetModule,
    NbStepperModule,
    GuidedTourModule,
    HttpClientModule,
    AppRoutingModule,
    NbSecurityModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbAuthModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    MonacoEditorModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    ThemeModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA  ],

  declarations: [AppComponent, LoginComponent, LogoutComponent],
  providers: [GithubService,
    GuidedTourService,
     {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: Interceptor,
    multi: true,
  },
  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },],
  bootstrap: [AppComponent],
})
export class AppModule {
}



